<template>
	<div>
		<!-- Modal -->
		<div class="modal fade" id="addToFavList" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog " role="document">
				<div class="modal-content ">
					<div class="modal-header bg-primary">
						<h5 class="modal-title text-white" id="exampleModalLabel">{{ $t('Añadir producto a lista de favoritos') }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div :class=" { 'modal-body': true, 'block-loading': favlistModalLoading }">
						<div class="row">
							<div class="col-md-12">
								<div class="table_desc mt-3 mb-4">
									<div class="cart_page table-responsive">
										<table>
											<thead>
												<tr>
													<th>REF</th>
													<th width="70">IMG</th>
													<th>{{ $t('Producto') }}</th>
													<th width="75" class="unitspp">{{ $t('Unidades') }}</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td>{{ favlistItem.ref_number }}</td>
													<td><img v-if="favlistItem.ref_image" :src=" getBaseUrl + getImgUrl + favlistItem.ref_image " class="product_thumb"></td>
													<td class="text-left">{{ favlistItem.ref_description }}</td>
													<td>
														<input 
															v-model.number=" favlistItemQuantity " 
															v-focus=" favlistItemQuantityFocused "
															@blur="favlistItemQuantityFocused = null"
															type="number" min="0" class="text-right"
														>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-md-12">
								<label>{{ $t('Elige tu servicio') }}:</label>	
								<select v-model="servicesIdSelected">
									<option value="0" disabled>{{ $t('Elige tu servicio') }}</option>
									<option v-for=" item in services " :key="item.srv_id" :value="item.srv_id">{{ item.srv_name }}</option>
								</select>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12 mt-4">
								<label>{{ $t('Crear nueva lista de favoritos') }}:</label>
								<form @submit.prevent="addFavlist" class="form-inline">
									<div class="input-group" style="width: 300px;">
										<input 
											v-model=" favlistNameNew " 
											:placeholder=" $t('Nombre') "
											type="text"
										>
									</div>
									<button 
										type="submit" 
										:disabled=" !favlistNameNewValid "
										class="btn-biv c-bg-grey-blue"><i class="fa fa-plus-circle"></i>
									</button>
								</form>
							</div>
							<div class="col-md-12 mt-4">
								<label>{{ $t('Elige tu lista de favoritos') }}:</label>
								<select v-model="favlistIdSelected">
									<option value="0" disabled>{{ $t('Elige tu lista de favoritos') }}</option>
									<option v-for=" item in serviceSelectedFavlistsSorted " :key="item.fvl_id" :value="item.fvl_id">{{ item.fvl_name }} ({{ item.fvl_count > 0 ? item.fvl_count : 0 }})</option>
								</select>
							</div>
						</div>
					</div>
					<div class="modal-footer mt-4">
						<button @click=" navToFavlists() " class="btn c-bg-blue-darker mouse-hover mr-auto">{{ $t('Ver listas de favoritos') }}</button>
						<button 
							@click=" addRefToFavlist() "
							:disabled=" favlistIdSelected == 0 "
							type="button" class="btn c-bg-grey-blue text-white mouse-hover">{{ $t('Añadir producto') }}</button>
						<button type="button" class="btn c-bg-blue-darker ml-2 mouse-hover" data-toggle="modal" data-target="#addToFavList">{{ $t('Cerrar') }}</button>
					</div>
				</div>
			</div>
		</div>

		<div v-if="loading" class="row">
			<div class="col-md-12">
				<spinner></spinner>
			</div>
		</div>

		<div v-else class="row">
			<div class="col-md-10">
				<div :class=" 'product_title bg_'+ getRouteLineName()">{{ products.typ_name }}</div>
			</div>
			<div class="col-md-2">
				<router-link :to=" { name: 'subcategory', params: { language: getLocale, sct: getSubcategory  } } " :class=" 'btn-back text-center bg_'+ getRouteLineName()" exact><i class="fa fa-chevron-left mr-2"></i>{{ $t('Volver') }}</router-link>
				<div class="spacer h20"></div>
			</div>			

			<div class="col-md-4 text-center">
				<img v-if="products.typ_image" :src=" getBaseUrl + getImgUrl + products.typ_image " class="type-max-height-img" alt="">
			</div>

			<div class="col-md-8">
				<div class="product_details">
          <h3>{{ products.typ_name }}</h3>
					<div class="product_description">
          	<!-- <p>{{ products.typ_description }}</p> -->
						<p v-html="products.typ_description"></p>
         </div>
        </div>
			</div>
			<div class="col-md-12">
				<div class="spacer h20"></div>
				<div class="table_desc">
          <div class="cart_page table-responsive">
          	<table :class=" { 'loading': getShoppingCartLoading } ">
		          <thead>
	              <tr>
                  <!-- <th width="30">Imagen</th> -->
                  <th width="80">Ref</th>
                  <th class="text-left">{{ $t('Descripción') }}</th>                  
                  <th width="40"><i v-tooltip:top.live="$t('Ficha técnica')" class="fa fa-file-text mouseHover"></i></th>
									<template v-if=" getLoggedIn ">
										<th width="100" class="text-right">{{ $t('Precio') }}</th>
										<th width="30"><i v-tooltip:top.live=" $t('Disponibilidad') " class="fa fa-bar-chart mouseHover"></i></th>
										<th width="90">{{ $t('uds.') }}</th>
										<th width="115"><i class="fa fa-shopping-cart"></i></th>
										<th v-if=" getFavlistsVisibility " width="45"><i class="fa fa-star"></i></th>
									</template>
	              </tr>
		          </thead>
		         	<template v-if=" products.hasOwnProperty('references') ">
	          		<tbody>
			            <tr v-for=" (item, index) in products.references " :key="index" :class="{ 'in-cart font-weight-bold': ( item.ref_quantity > 0 ) ? true : false }">		              
			              <td class="">{{ item.ref_number }}</td>
			              <td class="text-left">{{ item.ref_description }}</td>			              
			              <td>
			              	<a v-if=" item.ref_datasheet " :href=" getBaseUrl + getPdfUrl + item.ref_datasheet " v-tooltip:top.live="$t('Ficha técnica')" target="_blank" class="pdf-download"><i class="fa fa-file-pdf-o"></i></a> 
			              	<span v-else v-tooltip:top.live=" $t('En proceso...')" class="mouseHover"><i class="fa fa-file-pdf-o grey"></i></span>
			              </td>
										<template v-if=" getLoggedIn ">
											<td class="text-right black">{{ (item.ref_price > 0) ? toCurrency(item.ref_price) : $t('consultar') }}</td>
											<template v-if=" item.ref_price > 0 ">
												<td class="stock">
													<i v-if=" item.ref_stock == 'green' " class="fa fa-circle green"></i>
													<i v-else-if=" item.ref_stock == 'yellow' " class="fa fa-circle yellow"></i>
												</td>
												<td class="text-right">
													<template v-if=" item.ref_quantity == 0 || item.editing ">
														<input 
															v-model=" item.updateValue " 
															placeholder="0"
															@keyup.enter=" ( item.editing ) ? updateItem(item, index) : addItem(item, index) " 
															@change=" setAvailability(item) "
															@keyup=" setAvailability(item) "
															v-focus="index === focused"
															@focus="focused = index"
															@blur="focused = null"
															:tabindex=" index + 1 "
															type="number" min="0" class="text-right"
														>
													</template>
													<template v-else>
														<span class="mr-input">{{ item.ref_quantity }}</span>
													</template>
												</td>	
												<td class="text-right">
													<template v-if=" item.ref_quantity == 0 ">
														<button @click=" addItem(item, index) " class="btn-biv c-bg-grey-blue"><i class="fa fa-plus-circle"></i></button>
													</template>
													<template v-else>
														<template v-if=" item.editing"> 
															<button @click=" updateItem(item, index) "  class="btn-biv c-bg-grey-green"><i class="fa fa-floppy-o"></i></button>
														</template>
														<template v-else>
															<button @click=" editItem(item, index) " class="btn-biv c-bg-grey-blue"><i class="fa fa-pencil-square-o"></i></button>
														</template>
														<button  @click=" deleteItem(item) " class="btn-biv c-bg-grey-red"><i class="fa fa-trash"></i></button>
													</template>	
												</td>
												<td v-if=" getFavlistsVisibility ">
													<button @click=" setFavlistItem(item) " class="btn-biv c-bg-grey-blue" data-toggle="modal" data-target="#addToFavList"><i class="fa fa-star"></i></button>
												</td>
											</template>
											<template v-else>
												<td></td>
												<td></td>
												<td></td>
												<td v-if=" getFavlistsVisibility ">
													<button @click=" setFavlistItem(item) " class="btn-biv c-bg-grey-blue" data-toggle="modal" data-target="#addToFavList"><i class="fa fa-star"></i></button>
												</td>
											</template>
										</template>
			            </tr>         
	            	</tbody>
            	</template>
        		</table> 
      		</div>     
        </div>

				<div class="row">
					<div class="col-md-2 offset-md-10">
						<router-link :to=" { name: 'subcategory', params: { language: getLocale, sct: getSubcategory  } } " :class=" 'btn-back text-center bg_'+ getRouteLineName()" exact><i class="fa fa-chevron-left mr-2"></i>{{ $t('Volver') }}</router-link>
					</div>
				</div>
        
				<!-- <pre>
					{{ focused }}
				</pre> -->
			</div>
		</div>
	</div>
</template>

<i18n>
	{
		"es": {
			"Añadir producto a lista de favoritos": "Añadir producto a lista de favoritos",
			"Producto": "Producto",
			"Unidades": "Unidades",
			"Ficha técnica": "Ficha técnica",
			"Elige tu servicio": "Elige tu servicio",
			"Crear nueva lista de favoritos": "Crear nueva lista de favoritos",
			"Nombre": "Nombre",
			"Elige tu lista de favoritos": "Elige tu lista de favoritos",
			"Ver listas de favoritos": "Ver listas de favoritos",
			"Añadir producto": "Añadir producto",
			"Cerrar": "Cerrar",
			"Descripción": "Descripción",
			"Precio": "Precio",
			"Disponibilidad": "Disponibilidad",
			"uds.": "uds.",
			"En proceso...": "En proces...",
			"consultar": "consultar",
			"Volver": "Volver",
			"Error": "Error",
			"Tiene que añadir como mínimo una unidad al carrito!": "Tiene que añadir como mínimo una unidad al carrito!",
			"Borrado": "Borrado",
			"¿Estás seguro de borrar el elemento del carrito?": "¿Estás seguro de borrar el elemento del carrito?",
			"Si, bórralo!": "Si, bórralo!",
			"Ok": "Ok"
		},
		"en": {
			"Añadir producto a lista de favoritos": "Add product to favorites list",
			"Producto": "Product",
			"Unidades": "Units",
			"Ficha técnica": "Technical sheet",
			"Elige tu servicio": "Choose your service",
			"Crear nueva lista de favoritos": "Create new favorites list",
			"Nombre": "Name",
			"Elige tu lista de favoritos": "Choose your favorites list",
			"Ver listas de favoritos": "View favorites lists",
			"Añadir producto": "Add product",
			"Cerrar": "Close",
			"Descripción": "Description",
			"Precio": "Price",
			"Disponibilidad": "Availability",
			"uds.": "units",
			"En proceso...": "In process...",
			"consultar": "ask",
			"Volver": "Go back",
			"Error": "Error",
			"Tiene que añadir como mínimo una unidad al carrito!": "You have to add at least one unit to the cart!",
			"Borrado": "Delete",
			"¿Estás seguro de borrar el elemento del carrito?": "Are you sure to delete the item from the cart?",
			"Si, bórralo!": "Yes, delete it!",
			"Ok": "Ok"
		}
	}
</i18n>

<script>
	import { mixin as focusMixin }  from 'vue-focus';

	import Spinner from './helpers/Spinner.vue';

	import { mapGetters, mapMutations, mapActions } from 'vuex';
	import { mixinGlobal } from './../mixins/mixinGlobal';

  export default {
    mixins: [ mixinGlobal, focusMixin ],
		components: { Spinner },
	  data () {
	    return {
	      loading: false,
				rawItems: [],
				products: [],
				focused: null,
				services: [],
				servicesIdSelected: 0,
				serviceSelectedFavlists: [],
				favlistModalVisbility: false,
				favlistModalLoading: false,
				favlistItem: {},
				favlistItemQuantity: 1,
				favlistItemQuantityFocused: false,
				favlistNameNew: '',
				favlistIdSelected: 0,
				mdl: null
	    }
	  },
	  mounted(){
			this.loadProducts()

			if( this.getLoggedIn ){
				//this.loadServices()
				this.services = this.getServices
				this.servicesIdSelected = this.getSelectedService
				this.favlistIdSelected = this.getSelectedFavlist
			} 
					
			/* if( this.servicesIdSelected > 0 ){
				console.log('mounted')
				this.loadFavlists()
			} */

			this.mdl = $('#addToFavList')
			this.mdl.on('hide.bs.modal', () => {
				this.favlistModalVisbility = false
				//console.log(this.favlistModalVisbility)
			})
			this.mdl.on('shown.bs.modal', () => {
				this.favlistModalVisbility = true
				this.favlistItemQuantityFocused = true				
				//console.log(this.favlistModalVisbility)
			})
		},
    computed: {	
			...mapGetters( ['getLocale', 'getApiUrl', 'getBaseUrl', 'getRouteParams', 'getPdfUrl', 'getImgUrl', 'getLoggedIn', 'getShoppingCart', 'getShoppingCartLoading', 'getSubcategory', 'getSelectedService', 'getSelectedFavlist', 'getLoggedIn', 'getFavlistsVisibility', 'getServices'] ),
			serviceSelectedFavlistsSorted: function(){
				//console.log( this.serviceSelectedFavlists.length > 0 )
				if( this.serviceSelectedFavlists.length > 0 ){
					return this.serviceSelectedFavlists.sort((a, b) => a.fvl_name.localeCompare(b.fvl_name))
				}else{
					return '' 
				}
				//return this.serviceSelectedFavlists
			},
			favlistNameNewValid: function () {
				if( this.favlistNameNew.length < 3  ){
					return false
				}else{
					//console.log(this.serviceSelectedFavlists)
					if( this.serviceSelectedFavlists.length > 0 ){
						let found = this.serviceSelectedFavlists.find(element => element.fvl_name.toLowerCase().trim() == this.favlistNameNew.toLowerCase().trim() )
						if ( found === undefined ){
							return true
						}else{
							return false
						}
					}else{
            return true
          }
				}
			}
    },
    methods: {
			...mapMutations(['mutateShoppingCartLoading', 'mutateSelectedService', 'mutateSelectedFavlist']),
			...mapActions(['addItemShoppingCart', 'deleteItemShoppingCart', 'loadShoppingCart', 'updateItemShoppingCart', 'mutateGlobalMessage']),
      loadProducts(){
      	let lineId = this.getRouteLineId();
      	let categoryId = this.getRouteCategoryId();
      	let subcategoryId = this.getRouteSubcategoryId();
      	let typeId = this.getRouteTypeId();

        this.startLoading();

        this.$axios.get(this.getApiUrl + 'productos.php?lin=' + lineId + '&typ=' + typeId)
        .then( (respuesta) =>{  

					if( this.checkResponseData(respuesta.data) ){
						this.rawItems = respuesta.data.data

						this.products = Object.assign({}, this.rawItems)

						// Add/initialize quantities and uploadValues
						if (this.products.hasOwnProperty('references')) {
							this.products.references.forEach(element => {
								this.$set(element, 'ref_quantity', 0)
								this.$set(element, 'updateValue', 0)
								this.$set(element, 'editing',  false)
								this.$set(element, 'ref_stock', 0)
							});
						}

						this.$nextTick(() => {
							$(function () {
								$('[data-toggle="tooltip"]').tooltip()
							})
						})

						this.$store.dispatch('loadShoppingCart');						

					}else{
						this.$store.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: this.$t('Error'), message: respuesta.data } )
					}  				
          this.stopLoading();
        })  
        .catch( (error) =>{ 
					let  message = '';
					if (error.response.data.hasOwnProperty('message')) {
						message = error.response.data.message;
					}else{
						message = error
					}
					this.$store.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: this.$t('Error'), message:   message } )
					this.stopLoading();
        })            
			}, 
			addItem(item, index){
				if( item.updateValue < 1 ){
					this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message: this.$t('Tiene que añadir como mínimo una unidad al carrito!') } )					
				}else{
					this.$store.dispatch('addItemShoppingCart', item);
					this.focused = index + 1;
				}
			},
			editItem(item, index){
				item.editing = true;
				item.updateValue = item.ref_quantity;
				this.focused = index;
			},
			updateItem(item, index){
				if( item.updateValue < 1 ){
					this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message: this.$t('Tiene que añadir como mínimo una unidad al carrito!') } )
				}else{
					this.$store.dispatch('updateItemShoppingCart', item);

					// !!!!!!
					item.editing = false;
					this.focused = index + 1;
				}
			},
			deleteItem(item){
				this.$swal.fire({
					title: this.$t('Borrado'),
					html: this.$t('¿Estás seguro de borrar el elemento del carrito?') + '<br><i><b>' + item.ref_description + '</b></i>',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: this.$t('Si, bórralo!'),
					showClass: {
            popup: 'animated', // zoomIn
					},
					customClass: {
            confirmButton: 'btn c-bg-grey-blue text-white swal-btn',
            cancelButton: 'btn c-bg-blue-darker text-white swal-btn',
            title: 'swal-title',
            content: 'swal-content'
          }
				}).then((result) => {
					if( result.value ) {
						this.$store.dispatch('deleteItemShoppingCart', item);
					}
				})
			},
			calcAvailability(item){
				let quantity = item.updateValue > 0 ? item.updateValue : item.ref_quantity

				if ( quantity > 0 ){
					if( ( item.ref_status <= 3) || (  item.ref_status <= 10 && quantity >=  item.ref_status * 0.5 ) || (  item.ref_status > 10 && quantity >=  item.ref_status * 0.9 ) ){
						return 'yellow'
					}else{
						return 'green'
					}
				}else{
					return ''
				}
			},
			setAvailability(item){
				this.$set(item, 'ref_stock', this.calcAvailability(item))
			},
			/* loadServices(){
				//this.favlistModalLoading = true
        this.$axios.get(this.getApiUrl + 'servicios.php')
        .then( (respuesta) =>{ 
          this.services = respuesta.data
					//this.punchOutServicio = respuesta.data.length == 1 ? respuesta.data[0].srv_id : 0
					//this.favlistModalLoading = false
        })
        .catch( (error) =>{ 
          let  message = '';
          if (error.response.hasOwnProperty('data')){
            if (error.response.data.hasOwnProperty('message')) {
              message = error.response.data.message;
            }else{
              message = error
            }
          }else{
            message = error
            this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message: message } )
            this.stopLoading();
					}
					//this.favlistModalLoading = false
        })     
			}, */
			loadFavlists(){
				this.favlistModalLoading = true
				this.$axios.get(this.getApiUrl + 'favoritos.php?srv_id=' + this.getSelectedService)
        .then( (respuesta) =>{ 
          this.serviceSelectedFavlists = respuesta.data.data
					this.favlistModalLoading = false
        })
        .catch( (error) =>{ 
          let  message = '';
          if (error.response.hasOwnProperty('data')){
            if (error.response.data.hasOwnProperty('message')) {
              message = error.response.data.message;
            }else{
              message = error
            }
          }else{
            message = error            
					}
					this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message:   message } )
					this.favlistModalLoading = false
        }) 
			},
			addFavlist(){
				this.favlistModalLoading = true
				this.$axios.post(this.getApiUrl + 'favoritos.php', { fvl_name: this.favlistNameNew.trim(), fvl_srvid: this.getSelectedService })
        .then( (respuesta) =>{ 
					let newList = respuesta.data.data[0]
					this.favlistIdSelected = newList.fvl_id

					this.loadFavlists()
					this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'success', title: this.$t('Ok'), message: respuesta.data.message } )
					this.favlistNameNew = ''
					this.favlistModalLoading = false
        })
        .catch( (error) =>{ 
          let  message = '';
          if (error.response.hasOwnProperty('data')){
            if (error.response.data.hasOwnProperty('message')) {
              message = error.response.data.message;
            }else{
              message = error
            }
          }else{
            message = error            
					}
					this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message:   message } )
					this.favlistModalLoading = false
				}) 
			},
			addRefToFavlist(){
				//console.log(this.favlistItem)
				this.favlistModalLoading = true
				this.$axios.post(this.getApiUrl + 'favoritos.php', { fvl_id: this.getSelectedFavlist, ref_number: this.favlistItem.ref_number, ref_quantity: this.favlistItemQuantity, lin_id: this.favlistItem.lin_id } )
        .then( (respuesta) =>{ 
					this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'success', title: this.$t('Ok'), message: respuesta.data.message } )
					this.favlistModalLoading = false
					this.mdl.modal('hide')
        })
        .catch( (error) =>{ 
          let  message = '';
          if (error.response.hasOwnProperty('data')){
            if (error.response.data.hasOwnProperty('message')) {
              message = error.response.data.message;
            }else{
              message = error
            }
          }else{
            message = error            
					}
					this.$store.commit('mutateGlobalMessage', { toast: true, icon: 'error', title: this.$t('Error'), message:   message } )
					this.favlistModalLoading = false
				}) 
			},
			setFavlistItem(item){
				this.favlistItem = Object.assign({}, item);
				this.$set(item, 'quantity', 1);
			},
			navToFavlists(){
				this.mdl.modal('hide')
				this.$router.push({ name: 'user-favlists', params: { language: this.getLocale } })
			}
    },
    watch:{
      $route (to, from){
				this.products = Object.assign({}, this.rawItems);
				this.loadProducts()

				if (this.products.hasOwnProperty('references')) {
					this.products.references.forEach(element => {
						let obj = this.getShoppingCart.find( (elm) => elm.ref_number == element.ref_number )
						this.$set(element, 'ref_quantity', ( typeof obj === "undefined" ) ? 0 : obj.ref_quantity );
						this.$set(element, 'updateValue',  '');
						this.$set(element, 'editing',  false);
					});
				}			
			},
			getShoppingCart: function(newValue, oldValue) {
				// Merge rawItems & Shoppingcart when shoppingCart changes
				this.products = Object.assign({}, this.rawItems);

				if (this.products.hasOwnProperty('references')) {
					this.products.references.forEach(element => {
						let obj = newValue.find( (elm) => elm.ref_number == element.ref_number )
						this.$set(element, 'ref_quantity', ( typeof obj === "undefined" ) ? 0 : obj.ref_quantity );
						this.$set(element, 'updateValue',  '');
						this.$set(element, 'editing',  false)
						this.$set(element, 'ref_stock',  this.calcAvailability(element));
					});
				}				
			},
			servicesIdSelected (newValue, oldValue){
				//console.log(oldValue + ' | ' + newValue)
      	if( newValue != oldValue ){
          this.$store.commit('mutateSelectedService', newValue)
          if( oldValue != 0 ){
            this.$store.commit('mutateSelectedFavlist', 0)
        		this.favlistIdSelected = 0
          }
					this.loadFavlists()
				}
			},
			favlistIdSelected (newValue, oldValue){
      	if( newValue != oldValue && !(typeof newValue === 'undefined' ) ){
					this.$store.commit('mutateSelectedFavlist', newValue)
				}
			},
			/* favlistModalVisbility(newValue, oldValue){
				if( newValue && this.getSelectedService ){
					this.loadFavlists()
				}
			} */
		},

	}

</script>

<style type="text/css">
	.in-cart{ background-color: #F8F8F8 !important; }
	.mr-input{ margin-right: 15px; }
	.pdf-download{ color: #D40000; font-size: 15px; padding: 10px 10px;  }
	.pdf-download:hover{ color: #007bff; }
	.stock{ font-size: 16px; }
  .green{ color: #00CC00; }
  .yellow{ color: #FF9900; }
</style>

